import { combineReducers } from 'redux';
import { reducer as admin } from '../admin';
import { reducer as auth } from '../auth';
import { reducer as contacts } from '../contacts';
import { reducer as errors } from '../errors';
import { reducer as writing } from '../writing';
import { reducer as newContacts } from '../new-contacts';
import { reducer as newsletters } from '../newsletters';
import { reducer as outbox } from '../outbox';
import { reducer as schools } from '../schools';
import { reducer as newsletter } from '../newsletter';
import { reducer as user } from '../user';
import { reducer as notification } from '../notification';

const reducers = {
  admin,
  auth,
  contacts,
  errors,
  writing,
  newContacts,
  newsletters,
  outbox,
  schools,
  newsletter,
  user,
  notification,
};

export default combineReducers(reducers);
